import { GrEdit } from "react-icons/gr";

export const getEditCostStatus = (order) => {
  return order?.orCogs?.status &&
    order?.orDsFees?.status &&
    order?.orShipping?.status
    ? "Delivered"
    : "+add";
};

export const getEditCostBodyContent = (order) => {
  const completedCount = [
    order?.orCogs,
    order?.orShipping,
    order?.orDsFees,
  ].reduce((acc, obj) => (obj.status ? acc + 1 : acc), 0);

  return (
    <>
      <span>{completedCount}/3</span>
      <span>
        <GrEdit />
      </span>
      <span className="ml-2">Edit</span>
    </>
  );
};

// Add Claim
const orderClaimStatus = Object.freeze({
  Accept: "Accept",
  Cancel: "",
  Reject: "Returned",
  default: "+add",
});

// Function to get the status based on claimStatus
export const getOrderClaimStatus = (claimStatus) => {
  return orderClaimStatus[claimStatus] || orderClaimStatus.default;
};

export const getClaimDisplayValue = (order) => {
  const claimStatus = order?.claims?.claimStatus;
  const itemPrice = order?.claims?.itemPrice;
  if (claimStatus === "Accept" || claimStatus === "Cancel") {
    return `$${itemPrice}`;
  } else if (claimStatus) {
    return claimStatus;
  } else {
    return "+Add";
  }
};
